import React, { useEffect, useState, useMemo, useRef, useReducer } from 'react';
// import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { parse, format } from 'date-fns';
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
 

const preprocessDataForDataTable = (data) => {
  if (!Array.isArray(data)) {
    return []; 
  }

  const groupedData = {};

  data.forEach((item) => {
    const { buyer, shipper, shippingAgent, country, type, month, year} = item;
    const key = `${buyer}_${shipper}_${shippingAgent}_${country}_${type}_${month}_${year}`;

    if (groupedData[key]) {
      groupedData[key].quantityMT += item.quantityMT;
    } else {
      groupedData[key] = {
        buyer,
        shipper,
        shippingAgent,
        country,
        type,
        month,
        year,
        quantityMT: item.quantityMT,
      };
    }
  });

  return Object.values(groupedData);
};



const DataTable = ({ data1}) => {
  //states for pagination
   const[currentPage, setCurrentPage] = useState(0)
  const [postsPerPage, setPostsPerPage] = useState(15)
  const [currentItems, setCurrentItems] = useState([])
  const [pageCount, setPageCount] = useState(0)
  const data = preprocessDataForDataTable(data1)
  // const data = data1
 // console.log(data.length)
  //// console.log(preprocessDataForDataTable(data))
 // console.log("This is the data", data)

//processed data
//// console.log("This is the preprocessed data", preprocessDataForDataTable(data))

//ORIGINAL
const firstPostIndex = (currentPage) * postsPerPage;
const lastPostIndex = firstPostIndex + postsPerPage;
const slicedItems = data.slice(firstPostIndex, lastPostIndex);

const handlePageClick = (e) => {
  setCurrentPage(e.selected);
};

useEffect(() => {
  let token = localStorage.getItem('token')
  const num = Math.ceil(data.length / postsPerPage);
  setPageCount(num);
  
}, [data, postsPerPage]);

  const tableCellStyle = {
    border:"1px solid white",
    fontSize:"15px",
    textAlign: 'center',
    color: '#FFD584', 
  };
  
  const tableHeaderCellStyle = {
    padding:"5px",
    backgroundColor: '#FFD584',
    fontSize:"12.5px",
    border:"1px solid white",
    textAlign: 'center',
    color: '#044744',
  };
  
  const tableRowStyle = {
    borderBottom: '1px solid #ddd',
  };

  const tableStyle ={
    marginLeft:"25px",
    marginRight:"25Px",
    borderCollapse:"collapse",
    backgroundColor:'#055F5B',
    borderRadius:"20px",
  }

  return (
    <div style={{backgroundColor:'#044744'}}>
              
    <div className="row" style={{marginTop: 20}}>
        <div className="col-sm-12 col-xs-12 col-md-12">
            <table cellPadding="0" cellSpacing="0" className='table table-striped table-sm'>
              <thead style={{backgroundColor: '#FFD584', color: '#044744', textAlign: 'center', fontSize: 18, position: 'sticky'}}>
                <tr>
                  <th>BUYER</th>
                  <th>SHIPPER</th>
                  <th>SHIPPING AGENT</th>
                  <th>COUNTRY</th>
                  <th>TYPE</th>
                  <th>QUANTITY (MT)</th>
                  <th>MONTH</th>
                  <th>YEAR</th>
                </tr>
              </thead>
              <tbody>
                {slicedItems.map((item, index) => (
                  <tr key={index} style={tableRowStyle}>
                    <td style={tableCellStyle}>{item.buyer}</td>
                    <td style={tableCellStyle}>{item.shipper}</td>
                    <td style={tableCellStyle}>{item.shippingAgent}</td>
                    <td style={tableCellStyle}>{item.country}</td>
                    <td style={tableCellStyle}>{item.type}</td>
                    <td style={tableCellStyle}> {Math.round(item.quantityMT).toLocaleString()}</td>
                    <td style={tableCellStyle}>{item.month}</td>
                    <td style={tableCellStyle}>{item.year}</td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
    </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20,}}>
      <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"} />

</div>

    </div>
  );
};


const preprocessDataForLineChart = (data) => {
  const groupedData = {};
  data.forEach((item) => {
    const dateKey = item.date;
    if (groupedData[dateKey]) {
      groupedData[dateKey].quantityMT += item.quantityMT;
    } else {
      groupedData[dateKey] = { date: dateKey, quantityMT: item.quantityMT };
    }
  });
  return Object.values(groupedData);
};


const LineChart = ({ data }) => {
  const preprocessedData = preprocessDataForLineChart(data);

  const dates = preprocessedData.map((item) => {
    const [month, year] = item.date.split(' ');
    const formattedDate = `${month} 01 ${year}`;
    const dateObject = parse(formattedDate, 'MMM dd yyyy', new Date());
    dateObject.setHours(0, 0, 0, 0);
    const isoDateString = dateObject.toISOString();
  
    return isoDateString;
  });
  

  const quantities = preprocessedData.map((item) => item.quantityMT);
  const options = {
    chart: {
      id: 'area-chart',
      type: 'area',
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
        tools: {
          pan: false,
          selection: false,
          zoom: false,
          download: false,
        },
      },
      foreColor: '#ffd584', 
    },
    dataLabels:{
      enabled:false
    },
    xaxis: {
      type: 'datetime',
      categories: dates,
      title: {
        // text: 'Date',
        style: {
          color: '#ffd584',
        },
      },
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM \'yy'
        },
        style: {
          colors: '#ffd584', 
        },
        datetimeUTC: false
      },
      axisBorder: {
        color: '#ffd584',
      },
    },
    yaxis: {
      title: {
        text: 'Sum of Quantity (MT)',
        style: {
          color: '#ffd584', 
        },
      },
      labels: {
        style: {
          colors: ['#ffd584'], // Y-axis tick label color (Note: Use an array)
          fontSize: '12px',
          fontWeight:"400"
        },
        formatter:function (value) {
          return parseFloat(value).toFixed(0); // Format as an integer (no decimal places)
        }
      },
      axisBorder: {
        show: true, // Show the Y-axis line
        color: '#ffd584', // Y-axis line color
      },
      tooltip: {
        enabled: true,
      },
      labels: {
        formatter: function (val) {
          return Math.round(val).toLocaleString();
        }
      }
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'butt',
      width: 1,
      dashArray: 0,      
  },
  tooltip: {
    x: {
      format: 'MMMM yyyy'
    }
  },
  
    
  };

  const series = [
    {
      name: 'Quantity (MT)',
      data: quantities,
      color: '#ffd584', // Line color
    },
  ];

  return (
    <div>
      {/* <ReactApexChart options={options} series={series} type="area" height={350} /> */}
    </div>
  );
};



const Imports = () => {
    //Data
    const [data, setData] = useState([]);
    const [selectedDropdown, setSelectedDropdown] = useState("");
    const [selectedMonth, setSelectedMonth] = useState('');

    const [selectedCommodity, setSelectedCommodity] = useState('');
    const [selectedCommodity1, setSelectedCommodity1] = useState(null)

    const [selectedCountry, setSelectedCountry] = useState(''); 
    const [selectedCountry1, setSelectedCountry1] = useState(null)

    const [selectedBuyer, setSelectedBuyer] = useState('');
    const [selectedBuyer1, setSelectedBuyer1] = useState(null)

    const [selectedShipper, setSelectedShipper] = useState('')
    const [selectedShipper1, setSelectedShipper1] = useState(null)

    const [selectedShippingAgent, setSelectedShippingAgent] = useState('')
    const [selectedType, setSelectedType] = useState('')
    const [selectedYear, setSelectedYear] = useState('')
    const [selectedMarketingYear, setSelectedMarketingYear] = useState('')
    {/**Dropdown of dropdowns */}
    const [options, setOptions] = useState([])
    const [sMonth, setSMonth] = useState(false)
    const [sCommodity, setSCommodity] = useState(false)
    const [sCountry, setSCountry] = useState(false)
    const [sBuyer, setSBuyer] = useState(false)
    const [sShipper, setSShipper] = useState(false)
    const [sShippingAgent, setSShippingAgent] = useState(false)
    const [sType, setSType] = useState(false)
    const [sMY, setSMY] = useState(false)
    const [sYear, setSYear] = useState(false)
    const [sLN2, setLN2] = useState(false)
    //filter for the dates
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    //preprocessed data
    const [preprocessedData, setPreprocessedData] = useState([])
    //heading for the chart
    const [heading, setHeading] = useState('Cotton');

    const countryRef = null;
    //clear filters
    const clearFilters = ()=>{

      setSelectedCountry1(null)
      setSelectedCountry('')

      setSelectedCommodity1(null)
      setSelectedCommodity('')

      setSelectedBuyer1(null)
      setSelectedBuyer('')

      setSelectedShipper1(null)
      setSelectedShipper('')

      setSelectedShippingAgent('')
      setSelectedType('')
      setSelectedYear('')
      setStartDate('')
      setEndDate('')
    }

    //heading handler
    const headingHandler = (e) =>{
      if(e.target.value.length > 0){
        setHeading(e.target.value)
      }
      else{
        setHeading('All Commodities')
      }
    } 

    const monthNum = (month) =>{
      const months = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
      };

      return months[month];
    }
  
     
    

    useEffect(() => {

      function monthToIndex(monthName) {
        const months = [
          'January', 'February', 'March', 'April',
          'May', 'June', 'July', 'August',
          'September', 'October', 'November', 'December'
        ];
      
        return months.indexOf(monthName);
      }

      const fetchData = async () => {
        try {
          const response = await fetch('http://localhost:8080/getImports2');;
          const datas = await response.json();
          const items = datas.map((data, index) => ({
            ...data,
            date: moment(new Date(data.year, monthToIndex(data.month), 1)).format("MMM YYYY")  
          }));
          items.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateA - dateB;
          });
      
          setData(items);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);

    const filterDataAndLog = (
      data,
      selectedMonth,
      selectedCommodity,
      selectedCountry,
      selectedBuyer,
      selectedShipper,
      selectedShippingAgent,
      selectedMarketingYear,
      selectedType,
      selectedYear,
      startDate,
      endDate
    ) => {
      const filteredData = data.filter(item => {
        // Existing filters
        const matchMonth = !selectedMonth || item.month === selectedMonth;
        const matchCommodity = !selectedCommodity || item.commodity === selectedCommodity;
        const matchCountry = !selectedCountry || item.country === selectedCountry;
        const matchBuyer = !selectedBuyer || item.buyer === selectedBuyer;
        const matchShipper = !selectedShipper || item.shipper === selectedShipper;
        const matchShippingAgent = !selectedShippingAgent || item.shippingAgent === selectedShippingAgent;
        const matchMarketingYear = !selectedMarketingYear || item.marketingYear === selectedMarketingYear;
        const matchType = !selectedType || item.type === selectedType;
        const matchYear = !selectedYear || item.year === selectedYear;
        const itemDate = new Date(item.date);
        const startDateCondition = !startDate || itemDate >= new Date(startDate);
        const endDateCondition = !endDate || itemDate <= new Date(endDate);


        // Combine all conditions
        const satisfiesFilters =
          matchMonth &&
          matchCommodity &&
          matchCountry &&
          matchBuyer &&
          matchShipper &&
          matchShippingAgent &&
          matchMarketingYear &&
          matchType &&
          matchYear &&
          startDateCondition &&
          endDateCondition;
    
        return satisfiesFilters;
      });
    
      return filteredData;
    };
    
    // Use the filterDataAndLog function whenever the filter values change
    const filteredData1 = filterDataAndLog(
      preprocessedData,
      selectedMonth,
      selectedCommodity,
      selectedCountry,
      selectedBuyer,
      selectedShipper,
      selectedShippingAgent,
      selectedMarketingYear,
      selectedType,
      selectedYear,
      startDate,
      endDate
    );

    //adding a field for date
    useEffect(()=>{
       // console.log(data)
    }, [data])

    //compare function for AZ order
    const compareFn = (a,b) =>{
      const a1 = a.value
      const b1 = b.value
      if(a1 < b1){
        return -1;
      }
      if(a1 > b1){
        return 1
      }
      return 0
    }

        // Extract all unique country values from the data
    const uniqueCommodities = Array.from(new Set(filteredData1.map(item => item.commodity)))
    const uniqueCommoditiesOptions0= uniqueCommodities.map((item)=>({
      value:item,
      label:item
    }))
    uniqueCommoditiesOptions0.sort(compareFn)
    const selectAllOptionCo = { value: "Select All", label: "Select All" };
    const uniqueCommoditiesOptions = [selectAllOptionCo].concat(uniqueCommoditiesOptions0);

    const uniqueCountries = Array.from(new Set(data.map(item => item.country)));
    const uniqueCountriesOptions0= uniqueCountries.map((item)=>({
      value:item,
      label:item
    }))
    uniqueCountriesOptions0.sort(compareFn)
    const selectAllOptionC = { value: "Select All", label: "Select All" };
    const uniqueCountriesOptions = [selectAllOptionC].concat(uniqueCountriesOptions0);

    const uniqueBuyers = Array.from(new Set(filteredData1.map(item => item.buyer)));
    const uniqueBuyersOptions0= uniqueBuyers.map((item)=>({
      value:item,
      label:item
    }))
    uniqueBuyersOptions0.sort(compareFn)
    const selectAllOptionB = { value: "Select All", label: "Select All" };
    const uniqueBuyersOptions = [selectAllOptionB].concat(uniqueBuyersOptions0);

    const uniqueShippers = Array.from(new Set(filteredData1.map(item => item.shipper)));
    const uniqueShippersOptions0= uniqueShippers.map((item)=>({
      value:item,
      label:item
    }))
    uniqueShippersOptions0.sort(compareFn)
    const selectAllOption = { value: "Select All", label: "Select All" };
    const uniqueShippersOptions = [selectAllOption].concat(uniqueShippersOptions0);

    const uniqueShippingAgents = Array.from(new Set(filteredData1.map(item => item.shippingAgent)));
    const uniqueType = Array.from(new Set(filteredData1.map(item => item.type)));
    const uniqueMY = Array.from(new Set(filteredData1.map(item => item.marketingYear)));
  
   useEffect(()=>{

    const items = data.map(item => ({ ...item }));
    setPreprocessedData(items)

   }, [data])


      useEffect(()=>{
       // console.log(selectedYear)
      })
    
      const buttonstyle = {
        all:"unset",
        marginLeft:"20px",
        marginTop:"5px",
        backgroundColor: '#044744',
        borderColor:"#044744",
        borderRadius:"0px",
        padding:"0px !important",
        color: 'white', // Text color
      };
          

      const handleCountrySelection = (selectedOption) => {
        const { value, label } = selectedOption;
        if (value === "Select All") {
          setSelectedCountry('');
          setSelectedCountry1(null)
        } else {
          setSelectedCountry(label);
          setSelectedCountry1(selectedOption)
        }
      };

      const handleCommoditySelection = (selectedOption) => {
        const { value, label } = selectedOption;
        if (value === "Select All") {
          setSelectedCommodity('');
          setSelectedCommodity1(null)
        } else {
          setSelectedCommodity(label);
          setSelectedCommodity1(selectedOption)
        }
      };

      const handleShipperSelection = (selectedOption) => {
        const { value, label } = selectedOption;
        if (value === "Select All") {
          setSelectedShipper('');
          setSelectedShipper1(null)
        } else {
          setSelectedShipper(label);
          setSelectedShipper1(selectedOption)
        }
      };

      const handleBuyerSelection = (selectedOption) => {
        const { value, label } = selectedOption;
        if (value === "Select All") {
          setSelectedBuyer('');
          setSelectedBuyer1(null)
        } else {
          setSelectedBuyer(label);
          setSelectedBuyer1(selectedOption)
        }
      };

      

      
    return (
      <div style={{backgroundColor: '#044744'}}>
      {/* <DashboardHeader /> */}
            <div className="container-fluid" style={{paddingTop: 10}}>
              <div className="row">
                  {/* <DashboardSidebar /> */}
                  <main className="col-md-9 ms-sm-auto col-lg-10"> 
                      <div style={{backgroundColor: "#044744" }}>
                        <h1 style={{display:"flex", justifyContent:"center", alignItems:"center",  margin:"0", color:'#ffd584'}}>{heading}   - Custom Import Data</h1>

                        {/**Side by side components */}
                        <div className="row" style={{marginTop: 10}}>


                        <div className="col-sm-4 col-xs-4 col-md-4">
                          <div className="form-group" style={{border: '1px solid white', padding: 20, paddingBottom: 28}}>
                              {/* Dropdown to select the commodity */}
                              <div className='row'>
                                  {/* Commodity filter */}
                                  <div className='col-md-6'>
                                    <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>Commodity</p>
                                      <Select   
                                          value={selectedCommodity1}
                                          onChange={sel => handleCommoditySelection(sel)}
                                          options={uniqueCommoditiesOptions}
                                        />
                                  </div>

                                  {/* Country filter */}
                                  <div className='col-md-6'>
                                  <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>Country</p>
                                      <Select
                                          value={selectedCountry1}
                                          onChange={sel => handleCountrySelection(sel)}
                                          options={uniqueCountriesOptions}
                                        />
                                  </div>
                              </div>

                              <div className='row' style={{marginTop: 10}}>

                                {/* Dropdown to select the shipper */}
                                <div className='col-md-6'>
                                  <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>Shipper</p>
                                     <Select   
                                          value={selectedShipper1}
                                          onChange={sel => handleShipperSelection(sel)}
                                          options={uniqueShippersOptions}
                                        />

                                  </div>
                                  {/**Dropdown for the buyer */}
                                  <div className='col-md-6'>
                                    <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>Buyer</p>
                                                                       
                                      <Select   
                                          value={selectedBuyer1}
                                          onChange={sel => handleBuyerSelection(sel)}
                                          options={uniqueBuyersOptions}
                                        />

                                  </div>

                              </div>

                              <div className='row' style={{marginTop: 10}}>
                                  <div className='col-md-6'>
                                    <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>Start Date</p>
                                    <input
                                          type="month"
                                          value={startDate}
                                          onChange={e => {
                                           // console.log(e.target.value)
                                            setStartDate(e.target.value)}}
                                          className="form-control form-control-md"
                                          style={{fontSize:"0.89rem"}}
                                        />
                                  </div>
                                  <div className='col-md-6'>
                                    <p className="col-md-12" style={{ color: 'white', fontSize: 16, fontWeight: 'bolder'}}>End Date</p>
                                    <input
                                      type="month"
                                      value={endDate}
                                      onChange={e => {
                                        setEndDate(e.target.value)}}
                                      className="form-control form-control-md"
                                      style={{fontSize:"0.89rem"}}
                                    />
                                  </div>
                              </div>
                              <div>
                                {/**Dropdown of dropdowns */} 
                                <div style={{ display: "flex", flexDirection: "column", textAlign:"left" }}>
                                  <select value={selectedMonth}
                                      style={{WebkitAppearance:"none", marginTop: "10px", borderColor:"white", fontSize:"15px", color:"white", paddingLeft:"5px", paddingTop:"5px",paddingBottom:"5px", width:"150px", backgroundColor:"#044744" }}
                                      onChange={e => {
                                        setOptions([...options, e.target.value])
                                        
                                        if(e.target.value === "Type"){
                                          setSType(true)
                                        }
                                        else if(e.target.value === "Shipping Agent"){
                                          setSShippingAgent(true)
                                        }
                                        else if(e.target.value === "Buyer"){
                                          setSBuyer(true)
                                        }
                                        else if(e.target.value === "Marketing Year"){
                                          setSMY(true)
                                        }
                                      }}>
                                    <option style={{color:"white"}} value="" > + Filters</option>
                                    <option value="Type">Type</option>
                                    <option value="Shipping Agent">Shipping Agent</option>
                                    <option value="Marketing Year">Marketing Year</option>
                                  </select>
                                </div>

                                  {/* Dropdown to select the shipping agent */}
                                  {sShippingAgent && 
                                  
                                  <div>
                                    <span style={{color:"white", fontSize:"12px"}}>Shipping Agent is              </span>
                                    <select
                                        style={{textDecoration:"underline",fontSize:"12px", width:"180px", backgroundColor:"#004744", borderColor:"#004744", color:"#FFD584"}}
                                          value={selectedShippingAgent}
                                          onChange={e => setSelectedShippingAgent(e.target.value)}
                                        >
                                        <option value="">All Shipping Agents</option>
                                        {uniqueShippingAgents.map((shippingAgent, index) => (
                                          <option key={index} value={shippingAgent}>
                                            {shippingAgent}
                                          </option>
                                        ))}
                                    </select>
                                    <button style={buttonstyle} type="button" onClick={()=>{
                                      setSShippingAgent(false)
                                      setSelectedShippingAgent('')
                                    }
                                      }>x</button>
                                  </div>
                                  }

                                  {/* Dropdown to select the type */}
                                  {sType &&
                                    <div>
                                      <span style={{color:"white", fontSize:"12px"}}>Type is  </span>
                                      <select
                                          value={selectedType}
                                          style={{textDecoration:"underline", fontSize:"12px", width:"180px", backgroundColor:"#004744", borderColor:"#004744", color:"#FFD584"}}
                                          onChange={e => setSelectedType(e.target.value)}
                                        >
                                        <option value="">All Type</option>
                                        {uniqueType.map((type, index) => (
                                          <option key={index} value={type}>
                                            {type}
                                          </option>
                                        ))}
                                      </select>
                                      <button style={buttonstyle} type="button" onClick={()=>{
                                        setSType(false)
                                        setSelectedType('')
                                      }
                                        }>x</button>
                                    </div>
                                  }

                                  {/* Dropdown to select the marketing year */}
                                  {sMY &&
                                  <div>
                                    <span style={{color:"white", fontSize:"12px"}}>Marketing Year is            </span>
                                    <select
                                      value={selectedMarketingYear}
                                      style={{textDecoration:"underline",fontSize:"12px", width:"180px", backgroundColor:"#004744", borderColor:"#004744", color:"#FFD584"}}
                                      onChange={e => setSelectedMarketingYear(e.target.value)}
                                    >
                                      <option value="">All Marketing Year</option>
                                      {uniqueMY.map((unique, index) => (
                                        <option key={index} value={unique}>
                                          {unique}
                                        </option>
                                      ))}
                                    </select>
                                    <button style={buttonstyle} type="button" onClick={()=>{
                                      setSMY(false)
                                      setSelectedMarketingYear('')
                                    }
                                      }>x</button>
                                  </div>
                                  }
                              </div>
                              <div className="row">
                              <button style={buttonstyle} type="button" onClick={() => {
                              clearFilters()}}><i><u>Clear Filters</u></i></button>
                              </div>
                          </div>
                        </div>

                        <div className="col-sm-8 col-xs-8 col-md-8">
                          <div className='card' style={{backgroundColor: '#044744', border: '1px solid #fff'}}>
                            <div id="lineChart" style={{ maxWidth: '100%', paddingLeft: 10, paddingRight: 10 }}>
                              {!sLN2 && <LineChart data={filteredData1} height='240' width='100%' />}
                            </div>
                          </div>
                        </div>

                        </div>
                        
                        <DataTable data1={filteredData1} />
                        
                      </div>
                  </main>
              </div>
            </div>
      </div>
    );
  };

export default Imports